import { useCallback } from 'react';
import { Input, TextArea } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { useRoleBuilder } from '../../hooks/useRoleBuilder';
import StartFromChips from './StartFromChips';

/** Step 1: role name (unique), optional description and Start from. */
function DetailsStep() {
  const { t } = useTranslation('people-access');
  const { name, description, startFrom, roles, nameTaken, takenName, setName, setDescription, chooseStartFrom } = useRoleBuilder();
  const handleName = useCallback((event) => setName(event.target.value), [setName]);
  const handleDescription = useCallback((event) => setDescription(event.target.value), [setDescription]);

  return (
    <div className="flex max-w-3xl flex-col gap-5">
      <Input
        id="role-builder-name"
        label={t('roles.builder.details.name')}
        placeholder={t('roles.builder.details.namePlaceholder')}
        value={name}
        onChange={handleName}
        error={nameTaken ? t('roles.builder.details.nameTaken', { name: takenName }) : undefined}
      />
      <div className="flex flex-col gap-1.5">
        <label htmlFor="role-builder-description" className="text-sm font-medium text-content-secondary">
          {t('roles.builder.details.description')}
        </label>
        <TextArea
          id="role-builder-description"
          rows={3}
          placeholder={t('roles.builder.details.descriptionPlaceholder')}
          value={description}
          onChange={handleDescription}
        />
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-sm font-medium text-content-secondary">{t('roles.builder.details.startFrom')}</p>
        <p className="text-xs text-content-muted">{t('roles.builder.details.startFromHint')}</p>
        <StartFromChips roles={roles} value={startFrom} onChange={chooseStartFrom} />
      </div>
    </div>
  );
}

export default DetailsStep;
